import { render } from "./visitas.vue?vue&type=template&id=3a51bf2c"
import script from "./visitas.vue?vue&type=script&lang=js"
export * from "./visitas.vue?vue&type=script&lang=js"

import "./visitas.vue?vue&type=style&index=0&id=3a51bf2c&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__